export default {
  home: 'Home',
  pleaseSelect: 'Please Select',
  toRight: 'to right',
  toLeft: 'to left',
  filterColumns: 'Filter columns',
  importExportUpdateSettings: 'Import export update settings',
  searchForTheTaskTypeName: 'Search for the task type name',
  taskTypeName: 'Task type name',
  status: 'status',
  description: 'description',
  priority: 'priority',
  startTime: 'start time',
  endTime: 'end time',
  createTime: 'create time',
  lastModifiedTime: 'last modified',
  triggerInterval: 'trigger interval',
  operate: 'operate',
  open: 'open',
  deactivate: 'deactivate',
  createANewTaskType: 'Create a new task type',
  editTheTaskType: 'Edit the task type',
  basicInformation: 'Basic information',
  associationProperties: 'Association properties',
  associativeTags: 'Associative tags',
  associateDocuments: 'Associate documents',
  namespace: 'Namespace',
  category: 'category',
  shortDescription: 'Short description',
  longDescription: 'Long description',
  documentBrowsing: 'Document browsing',
  associativeRelationships: 'Associative relationships',
  changeHistory: 'Change History',
  changes: 'Changes',
  beforeTheChange: 'Before the change',
  afterTheChange: 'After the change',
  fileName: 'fileName',
  documentName: 'documentName',
  onlyOneFileCanBeUploadedAtATime: 'Only one file can be uploaded at a time',
  or: 'or',
  clickUpload: 'Click Upload',
  pleaseSelectADirectoryType: 'Please select a directory type',
  pleaseSelectTheObjectEncoding: 'Please select the object encoding',
  nodataPressEnterToQuery: 'No data (press Enter to query)',
  pleaseSelectADocumentName: 'Please select a document name',
  identificationNamePrefixMatch: 'Identification name prefix match',
  tagCode: 'tagCode',
  tagName: 'tagName',
  tagClassName: 'tagClassName',
  documentCode: 'documentCode',
  identifier: 'identifier',
  addANewAssociation: 'Add a new association',
  editTheAssociation: 'Edit the association',
  pleaseSelectAFileName: 'Please select a file name',
  pleaseEnterADistinguishedName: 'Please enter a distinguished name',
  startDate: 'Start date',
  endDate: 'End date',
  entityName: 'Entity name',
  estimatedAmount: 'estimatedAmount',
  realAmount: 'realAmount',
  acquisitionTime: 'acquisitionTime',
  dailyReconciliation: 'Daily reconciliation',
  weeklyReconciliation: 'Weekly reconciliation',
  monthlyReconciliation: 'Monthly reconciliation',
  standardLibrary: 'Standard Library',
  propertyField: 'Property field',
  addTo: 'Add to',
  ruleName: 'rule Name',
  ruleDescription: 'rule Description',
  ruleContent: 'rule Content',
  regularRegularity: 'Regular regularity',
  runningStatus: 'Running status',
  frequencyOfExecution: 'Frequency of execution',
  lastRunTime: 'Last run time',
  lastRunStatus: 'Last run status',
  elapsedLastRunSeconds: 'Elapsed last run (seconds)',
  nextRunTime: 'Next run time',
  detail: 'detail',
  back: 'back',
  disassociate: 'disassociate',
  Whethertodisassociatethedata: 'Whether to disassociate the data',
  metaDataName: 'metaDataName',
  metaDataCode: 'metaDataCode',
  dataDesensitizationRule: 'dataDesensitizationRule',
  referenceData: 'referenceData',
  labelName: 'labelName',
  labelCode: 'labelCode',
  refresh: 'refresh',
  reset: 'reset',
  goToDatasetManagement: 'Go to Dataset Management',
  pleaseSelectABusinessCategory: 'Please select a business category',
  tableCode: 'Table code',
  entityName: 'Entity name',
  tableName: 'Table name',
}
